module.exports = __webpack_public_path__ + "static/img/hnlogo.117bca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hnlogo.png
// module id = HlrH
// module chunks = 1